import { GraphCanvas } from "@/components/flow/GraphCanvas";
import type { StrainGraph } from "@/types";

export function CanvasView({
  graph, fullscreen, onToggleFullscreen,
}: {
  graph: StrainGraph;
  fullscreen: boolean;
  onToggleFullscreen: () => void;
}) {
  return <GraphCanvas graph={graph} fullscreen={fullscreen} onToggleFullscreen={onToggleFullscreen} />;
}
